export default "__VITE_ASSET__B5VyFnX2__"